import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=12a12e6e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=12a12e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a12e6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a12e6e')) {
      api.createRecord('12a12e6e', component.options)
    } else {
      api.reload('12a12e6e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=12a12e6e&scoped=true&", function () {
      api.rerender('12a12e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NT4PYv3D7b24/JS/comp/DocBox.vue"
export default component.exports